import { uniqBy } from "lodash";

const MAX_AVOID_POINTS = 50;

class RestrictedPoints {

    restrictPoints = true;
    constructor() {
        this.points = [];
    }

    setRestrictPoints(restrictPoints) {
        this.restrictPoints = restrictPoints;
    }

    setPoints(points) {
        this.points = points;
    }

    getPoints() {
        return this.points;
    }

    addPoints(points) {
        this.points = this.points.concat(points);
        this.points = uniqBy(this.points, p => `${p.lat},${p.lon}`);
    }

    removePoint(pointIds) {
        this.points = this.points.filter(p => !pointIds.includes(p.stopId));
    }

    clearPoints() {
        this.points = [];
    }

    getGeoapifyAvoidQueryParam(coords) {
        if (!this.points?.length || !this.restrictPoints) {
            return '';
        }

        let closestPoints = this.points;

        if(closestPoints.length > MAX_AVOID_POINTS) {
            // Get distances from each restricted point to all coords
            const pointsWithMinDist = this.points.map(point => {
                const minDist = Math.min(...coords.map(coord => 
                    Math.sqrt(
                        Math.pow(point.lat - coord.lat, 2) + 
                        Math.pow(point.lon - coord.lon, 2)
                    )
                ));
                return {...point, minDist};
            });

            // Sort by minimum distance and take top 50
            closestPoints = pointsWithMinDist
                .sort((a, b) => a.minDist - b.minDist)
                .slice(0, MAX_AVOID_POINTS);
        }

        // Format each point as "lonlat:lon,lat"
        const avoidPoints = closestPoints.map(point => {
            return `location:${point.lat},${point.lon}`;
        });

        // Join with | and return as avoid=location|latetc
        return avoidPoints.join('|');
    }
}

// Create a singleton instance
const restrictedPoints = new RestrictedPoints();

export default restrictedPoints; 